import { MessageCircle, Send, Twitter, Linkedin, Mail, Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { useTranslation } from 'react-i18next';
export default function SocialShareButtons({ referralLink, onShareWhatsApp, onShareTelegram, onShareTwitter, onShareLinkedIn, onShareEmail, onCopyLink }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopyLink();
    setCopied(true);
    toast.success("Link copied to clipboard!");
    setTimeout(() => setCopied(false), 2000);
  };

  const buttons = [
    { label: "WhatsApp", icon: MessageCircle, color: "hover:border-green-500/50 hover:bg-green-500/5", iconColor: "text-green-400", onClick: onShareWhatsApp },
    { label: "Telegram", icon: Send, color: "hover:border-blue-500/50 hover:bg-blue-500/5", iconColor: "text-blue-400", onClick: onShareTelegram },
    { label: "Twitter", icon: Twitter, color: "hover:border-sky-500/50 hover:bg-sky-500/5", iconColor: "text-sky-400", onClick: onShareTwitter },
    { label: "LinkedIn", icon: Linkedin, color: "hover:border-blue-600/50 hover:bg-blue-600/5", iconColor: "text-blue-500", onClick: onShareLinkedIn },
    { label: "Email", icon: Mail, color: "hover:border-amber-500/50 hover:bg-amber-500/5", iconColor: "text-amber-400", onClick: onShareEmail },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {buttons.map((btn) => (
        <button
          key={btn.label}
          onClick={btn.onClick}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 border border-zinc-700 ${btn.color} transition-colors font-mono text-[11px] text-zinc-400`}
        >
          <btn.icon className={`w-4 h-4 ${btn.iconColor}`} />
          <span className="hidden sm:inline">{btn.label}</span>
        </button>
      ))}
      <button
        onClick={handleCopy}
        className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 border border-amber-500/30 bg-amber-500/5 hover:bg-amber-500/10 transition-colors font-mono text-[11px] text-amber-400"
      >
        {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
        {copied ? "Copied!" : "Copy Link"}
      </button>
    </div>
  );
}
